import { component as defineComponent } from 'flightjs';

var guaranteeModal = function () {
    this.attributes({
        actionItem: '[data-action]',
    });

    this.after('initialize', function () {
        this.on('click', {
            actionItem: this.triggerContestAction,
        });
        this.on(document, 'dataContestActionSucceeded', this.closeModal);
    });

    this.closeModal = function (event, data) {
        if (data.contest && data.contest.isPrizeGuaranteed) {
            if (this.$node.data('modal')) {
                this.$node.data('modal').hide();
            }

            this.trigger('uiModalClosed');
        }
    };

    this.triggerContestAction = function (event) {
        this.trigger('uiContestActionRequested', {
            url: $(event.currentTarget).data('action'),
        });

        event.preventDefault();
    };
};

export default defineComponent(guaranteeModal);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/contest-guarantee-modal.js